import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SiteContentModel } from 'src/app/models/site-content.model';
import { SiteContentService } from 'src/app/services/site-content.service';

@Component({
  selector: 'app-expander',
  templateUrl: './expander.component.html',
  styleUrls: ['./expander.component.scss'],
})
export class ExpanderComponent implements OnInit {

  @Input() key: string;
  @ViewChild('body') body: ElementRef<HTMLDivElement>;

  content: SiteContentModel;
  error: string;
  expanded = false;
  maxHeight: number = 0;

  constructor(private siteContentService: SiteContentService) { }

  expand() {
    this.expanded = !this.expanded;
    this.maxHeight = this.expanded ? this.body.nativeElement.scrollHeight : 0;
  }

  async ngOnInit() {
    try {
      this.content = await this.siteContentService.getSiteContent(this.key);
    } catch (err) {
      this.error = `Content ${this.key} not found`;
    }
  }

}
